// OT Watchlist — employees flagged for customer overtime.
import { ExportCsvButton } from '../../components/ui';
import { downloadCsv } from '../../utils/csv.js';
import { useInfoModal, PageChrome, InfoModal, dqBadgeFor } from './Chrome.jsx';
import { fmtN, SUB_PAGES } from './helpers.js';

// Dashboard tables arrive complete in the /api/dashboard payload, so the CSV
// is built here rather than re-queried — every row is already on the page.
const CSV_COLUMNS = [
  { key: 'employee_name',    label: 'Employee' },
  { key: 'ns_location_name', label: 'Location' },
  { key: 'weekly_hours',     label: 'Weekly Hours' },
  { key: 'records',          label: 'Records' },
];

export function PageWatchlist({ stats, nav }) {
  const info = useInfoModal();
  const helpEntry = SUB_PAGES.find((p) => p.id === 'watchlist');
  const rows = stats.ot_employees || [];

  return (
    <>
      <PageChrome
        title="OT Watchlist"
        subtitle={`${rows.length} employees flagged for customer overtime.`}
        onHome={() => nav.goSubPage('overview')}
        onBack={nav.goBack} canBack={nav.canBack}
        onInfo={info.onOpen}
        dqBadge={dqBadgeFor(stats, () => nav.goSubPage('data_quality'))}
      />

      {rows.length === 0 ? (
        <div className="db-empty">
          <div className="db-empty-title">No OT employees flagged</div>
          <div className="db-empty-sub">Nothing crossed the customer-OT threshold this period.</div>
        </div>
      ) : (
        <div className="db-card">
          <div style={{
            display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
            gap: 12, flexWrap: 'wrap',
          }}>
            <div className="db-card-title">Employees with customer overtime</div>
            <ExportCsvButton
              onExport={() => downloadCsv('ot-watchlist', rows, CSV_COLUMNS)}
              title="Download the OT watchlist as CSV"
            />
          </div>
          <div className="db-card-sub">
            These records may need scrutiny before billing — verify the customer-OT calculation is correct.
          </div>
          <table className="db-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Location</th>
                <th className="num">Weekly hours</th>
                <th className="num">Records</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((e, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 500 }}>{e.employee_name}</td>
                  <td>{e.ns_location_name}</td>
                  <td className="num" style={{ color: 'var(--db-orange)', fontWeight: 600 }}>
                    {(e.weekly_hours || 0).toFixed(1)}h
                  </td>
                  <td className="num">{fmtN(e.records || 0)}</td>
                  <td className="num">
                    <button type="button" className="btn btn-sm btn-primary"
                      onClick={() => nav.goRecords({ filter: 'all', customerOt: 'true' })}>
                      Open →
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <InfoModal open={info.open} onClose={info.onClose} title="About OT Watchlist" body={helpEntry?.help} />
    </>
  );
}
